import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    ServiceCenterFormType,
} from '../serviceCenters.types'

const fields: DTOCardFormField<keyof ServiceCenterFormType>[] = [{
    id: 'productMetrics',
    title: 'Product Metrics',
    className: 'productMetrics',
    fields: [{
        name: 'productMetrics',
        componentName: 'ProductMetrics',
        exists: true,
        required: true,
        showFields: {
            safeMinimumUsableStock: true,
        },
        disabled: true,
    }],
}]

export default fields
